import NiceModal from '@ebay/nice-modal-react'

import { ModalDownloadLandingPage } from './ModalDownloadLandingPage'

export const MODAL_DOWNLOAD_LANDING_PAGE = 'MODAL_DOWNLOAD_LANDING_PAGE'

NiceModal.register(MODAL_DOWNLOAD_LANDING_PAGE, ModalDownloadLandingPage)
